import type { Components, Theme } from '@mui/material';

export const MuiCheckbox: Components<Theme>['MuiCheckbox'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.Mui-checked, &.MuiCheckbox-indeterminate': {
        color: theme.palette.neutral.darker,
      },
    }),
  },
};
